import React from 'react';

import NwTimesButton from '@components/Gui/NwTimesButton';

import ArtDocumentMediaPreview from '@containers/Art/ArtDocumentMediaPreview';
import { getArtMediaDocumentId } from '@containers/Art/ArtDocuments';

import { StyledArticleMediaPreview } from './ArticleMediaPreview.styles';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/** Senza media rende emptyState, che il blocco usa come dropzone. */
const ArticleMediaPreview = ({ emptyState, hasMedia, media, onRemove }) => {
    if (!hasMedia) {
        return <StyledArticleMediaPreview className="is-empty">{emptyState}</StyledArticleMediaPreview>;
    }

    return (
        <StyledArticleMediaPreview>
            <NwTimesButton ariaLabel="Remove media" offset={8} onClick={onRemove} />
            <ArtDocumentMediaPreview
                documentId={getArtMediaDocumentId(media)}
                fallbackIcon={byPrefixAndName.fasl['image']}
                fallbackLabel="Article media"
                media={media}
                showControls
            />
        </StyledArticleMediaPreview>
    );
};

export default ArticleMediaPreview;
